module.exports = __webpack_public_path__ + "static/media/Lanre.c1eafb22.png";